'use strict';

var $ = require('jquery');

module.exports = function (remoteURL) {
    window.onerror = function (message, url, line, column, errorObj) {
        $.ajax({
            type: 'post',
            url: remoteURL,
            data: {
                message: message,
                script: url,
                url: window.location.href,
                line: line,
                column: column || '',
                stackTrace: errorObj ? errorObj.stack : '',
                agent: navigator.userAgent,
                platform: navigator.platform
            },
            async: true
        });
    };
};
